import { useQueue } from '../useQueue'
import { QueueStatus } from '../queue/queueTypes'
import { DocumentGenerationType } from '../document/documentGenerationTypes'

export type ErrorNotification = {
    message?: string
    trace?: string
    generationType?: DocumentGenerationType
    state?: string
}

/**
 * Fails the job an error notification belongs to. A notification for a job that is no longer queued is ignored by the
 * store, so nothing is needed here to guard against late arrivals.
 */
export default function useProcessErrorNotification() {
    const queue = useQueue()

    return (notification: ErrorNotification) => {
        queue.transition(notification.state, QueueStatus.Failed, {
            error: {
                message: notification.message,
                trace: notification.trace,
            },
        })
    }
}
